import axios from "axios";
const AxoisRequest = {
  getServerUrl() {
    try {

     return  process.env.REACT_APP_API_URL;
 
    } catch (error) {
      this.handleError(error);
    }
  },

  fetchUser() {
    try {
      let user = JSON.parse(sessionStorage.getItem("user"));

      return user;
    } catch (error) {
      this.handleError(error);
    }
  },

  storeToken(token) {
    try {
      sessionStorage.setItem("accessToken", token);
    } catch (error) {
      this.handleError(error);
    }
  },

  storeUser(user) {
    try {
      sessionStorage.setItem("user", JSON.stringify(user));
    } catch (error) {
      this.handleError(error);
    }
  },

  async signOut(voucher) {
    try {
      sessionStorage.clear();
      localStorage.clear();
      if(!voucher) return  window.location.href = "/";
      window.location.href = "/voucher"
    } catch (error) {
      await this.handleError(error);
    }
  },

  async getData(url, query = 0) {
    try {
      let SERVER_URL = this.getServerUrl();

      const config = {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
        },
        params: query,
   
      };

      let response = await axios.get(`${SERVER_URL}${url}`, config);
      return response.data;
    } catch (error) {
      // throw error;
      await this.handleError(error);
    }
  },

  async downloadfile(url, query = 0) {
    try {
      let SERVER_URL = this.getServerUrl();

      const config = {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
        },
        params: query,
        responseType : "blob"
      };

      
      let response = await axios.get(`${SERVER_URL}${url}`, config);
      const filename = response.headers['content-disposition']?.split('filename=')[1]
      const urls = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = urls
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click();
      document.body.removeChild(link); 
      window.URL.revokeObjectURL(url)
      return response

    } catch (error) {
      // throw error;
      await this.handleError(error);
    }
  },

  async getFile(url, query = 0) {
    try {
      let SERVER_URL = this.getServerUrl();

      const config = {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
        },
        params: query,
        responseType: "blob",
      };

      let response = await axios.get(`${SERVER_URL}${url}`, config);
      return response.data;
    } catch (error) {
      // throw error;
      await this.handleError(error);
    }
  },

  async checkAuth(query = 0) {
    try {
      let token = sessionStorage.getItem("accessToken");
      if (!token) return null;

      let SERVER_URL = this.getServerUrl();

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: query,
      };

      let response = await axios.get(`${SERVER_URL}/auth/check`, config);
      return response.data;
    } catch (error) {
      await this.handleError(error);
    }
  },

  async postData(url, data) {
    try {
      let SERVER_URL = this.getServerUrl();
 
      const config = {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
        },
      };

      let response = await axios.post(`${SERVER_URL}${url}`, data, config);
      
      return response.data;
    } catch (error) {
      // throw error;
      await this.handleError(error);
    }
  },

  async getDataNoAuth(url, data) {
    try {
      let SERVER_URL = this.getServerUrl();
      let response = await axios.get(`${SERVER_URL}${url}`, data);

      return response.data;
    } catch (error) {
      await this.handleError(error);
    }
  },

  async postDataNoAuth(url, data) {
    try {
      let SERVER_URL = this.getServerUrl();
      let response = await axios.post(`${SERVER_URL}${url}`, data);

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async postFormData(url, formData) {
    try {
      let SERVER_URL = this.getServerUrl();
      const token = sessionStorage.getItem("accessToken");

      if (!token) {
        throw new Error("Your session has expired. Please sign in again.");
      }

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      let response = await axios.post(`${SERVER_URL}${url}`, formData, config);
      return response.data;
    } catch (error) {
      await this.handleError(error);
    }
  },


  async downloadfile_no_progress(url, query = 0) {

    try {
      let SERVER_URL = this.getServerUrl();

      const config = {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
        },
 
        params: query,
        responseType : "blob",
        onUploadProgress: (progressEvent) => {
          // const progress = (progressEvent.loaded / progressEvent.total) * 50;
          // setProgress(progress);
       
        },
        onDownloadProgress: (progressEvent) => {
          // const progress = 50 + (progressEvent.loaded / progressEvent.total) * 50;
          // setProgress(progress);
      
        },
      };

      let response = await axios.get(`${SERVER_URL}${url}`, config);
      const filename =  response.headers['content-disposition']?.split('filename=')[1]
      const urls = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = urls
      link.setAttribute('download',`${filename}`)
      document.body.appendChild(link)
      link.click()
      link.remove()
      return response
    } catch (error) {
      // throw error;
      //await this.handleError(error);
      console.log(error);
    }
  },


  async handleError(error) {
    const status = error.response?.status;

    if (status === 401) {
      await this.signOut();
      throw new Error("Your session has expired. Please sign in again.");
    }

    if (status === 403) {
      throw new Error(error.response.data?.message || "You are not authorized to complete this action.");
    }

    if (error.response) {
      throw new Error(error.response.data?.message || error.response.data?.error || "The request could not be completed.");
    } else if (error.request) {
      throw error.request;
    } else {
      throw new Error(error.message);
    }
  },
};


export default AxoisRequest